import { DomainOutlined } from '@mui/icons-material'

import Routes from '@tabeeb/routes'
import { useSelector } from '@tabeeb/store'
import { hasTenantPermission } from '@tabeeb/modules/permissions/selectors'
import { TenantPermission } from '@tabeeb/enums'
import { NavbarItem } from '@collaborate-health/uikit'

const CorporationsTab: React.FC = () => {
  const display = useSelector((state) => hasTenantPermission(state, TenantPermission.ManageCorporations))
  if (!display) {
    return null
  }

  return <NavbarItem name='Corporations' href={Routes.corporations} icon={<DomainOutlined />} />
}

export default CorporationsTab

